import React, { useState, useContext } from "react";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import CardWrap from "../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { certificateService } from "../../Services/certificate.service";
import ResultModal from "../Common/ResultModal";
import DatePicker, { registerLocale } from "react-datepicker";
import iconcontentcalendar from "../../Images/Icons/iconcontentcalendar.png";
import * as dateHelper from "../../Helpers/DateHelper";
import Tooltip from "../Common/Tooltip";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import { lettersAndNumbers } from "../../Config/Regex";
registerLocale("hr", hr);
registerLocale("en", en);

const CertificateUpload = () => {
  const { locName, locTenant, selectedLanguageId } = useContext(GlobalContext);
  const history = useHistory();
  const { t: translator } = useTranslation();
  const [fileValidation, setFileValidation] = useState("");
  const [certificate, setCertificate] = useState({
    tenantId: locTenant,
    name: "",
    validFrom: null,
    validTo: null,
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  let formData = new FormData();

  const { register, handleSubmit, errors, control } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCertificate({ ...certificate, [name]: value });
  };

  const handleFileChange = (event) => {
    setFileValidation("");
    if (event.target.files[0].type != "application/x-pkcs12") {
      document.getElementsByName("file")[0].value = null;
      setFileValidation("Certifikat mora biti u P12 formatu.");
      return false;
    }
  };

  const onSubmit = () => {
    if (!document.getElementsByName("file")[0].value) {
      setFileValidation("Unos certifikata je obavezan!");
      return false;
    }

    formData.append("tenantId", Number(certificate.tenantId));
    formData.append(
      "fileContent",
      document.getElementsByName("file")[0].files[0]
    );
    formData.append("name", certificate.name);
    formData.append("certPassword", certificate.certPassword);
    formData.append("validFrom", certificate.validFrom);
    formData.append("validTo", certificate.validTo);

    certificateService
      .uploadCert(formData)
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("CertificateUpload-SuccesModal-Title"),
              text: translator("CertificateUpload-SuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("CertificateUpload-UnsuccesModal-Title"),
              text: translator(res.data.message),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("CertificateUpload-UnsuccesModal-Title"),
          text: translator("CertificateUpload-UnsuccesModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  const goBack = () => {
    history.push(`/${locName}/${locTenant}`);
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  const handleCancel = () => {
    goBack();
  };
  return (
    <CardWrap subtitle={translator("Certificate-Upload-Title")}>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Certificate-Upload-Legend")}
            </legend>

            <div className="form-group">
              <label>{translator("Certificate-Upload-Name")}</label>{" "}
              <Tooltip text={translator("Certificate-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                name="name"
                ref={register({
                  required: true,
                  maxLength: 50,
                  pattern: lettersAndNumbers,
                })}
                onChange={handleInputChange}
              />
              {errors.name && errors.name.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.name && errors.name.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength50")}
                </p>
              )}
              {errors.name && errors.name.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersAndNumbers")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Password")}</label>{" "}
              <Tooltip text={translator("Certificate-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                name="certPassword"
                ref={register({
                  required: true,
                  maxLength: 50,
                })}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>{translator("Certificate-Upload-File")}</label>
              <input
                type="file"
                className="form-control-file"
                name="file"
                onChange={handleFileChange}
              />
              <p className="text-danger">{fileValidation}</p>
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-CertificateData-Subscription")}
            </legend>
            <div className="form-group">
              <label>{translator("Certificate-Upload-ValidFrom")}</label>{" "}
              <Tooltip text={translator("Certificate-ValidFrom-Msg")} />
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <img src={iconcontentcalendar} alt="calendar" />
                  </span>
                </div>
                <Controller
                  as={DatePicker}
                  control={control}
                  autoComplete="off"
                  className="form-control"
                  dateFormat="dd.MM.yyyy"
                  name="validFrom"
                  showYearDropdown={true}
                  rules={{ required: true }}
                  locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                  valueName="selected"
                  onChange={function ([selected]) {
                    handleInputChange({
                      target: {
                        name: "validFrom",
                        value: dateHelper.datePickerDateToUtc(selected),
                      },
                    });
                    return selected;
                  }}
                  maxDate={
                    certificate.validTo != null
                      ? new Date(certificate.validTo)
                      : new Date(8640000000000000)
                  }
                />
              </div>
              {errors.validFrom && errors.validFrom.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Certificate-Upload-ValidTo")}</label>{" "}
              <Tooltip text={translator("Certificate-ValidTo-Msg")} />
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <img src={iconcontentcalendar} alt="calendar" />
                  </span>
                </div>
                <Controller
                  as={DatePicker}
                  control={control}
                  autoComplete="off"
                  className="form-control"
                  dateFormat="dd.MM.yyyy"
                  name="validTo"
                  showYearDropdown={true}
                  rules={{ required: true }}
                  locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                  valueName="selected"
                  onChange={function ([selected]) {
                    handleInputChange({
                      target: {
                        name: "validTo",
                        value: dateHelper.datePickerDateToUtc(selected),
                      },
                    });
                    return selected;
                  }}
                  minDate={
                    certificate.validFrom != ""
                      ? new Date(certificate.validFrom)
                      : new Date(8640000000000000)
                  }
                />
              </div>
              {errors.validTo && errors.validTo.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            </div>
          </fieldset>
        </div>

        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
};

export default CertificateUpload;
